import { getProductPriceFormatter } from "./getProductPriceFormatter";

export const getProductPriceText = (
  amount: number | undefined | null,
  currencyCode: string
): string => {
  if (!amount) {
    return "Variable";
  }

  const formatPrice = getProductPriceFormatter(currencyCode).format;

  return formatPrice(amount);
};
